import dates from '@unite-us/client-utils/dist/utils/dates';
import moment from 'moment';
export default function getDobData(dateOfBirth) {
  var birthData = dates.formatDate(dateOfBirth);
  var age = moment().diff(moment.unix(dateOfBirth), 'years');
  return "".concat(birthData, " (Age ").concat(age, ")");
}
//# sourceMappingURL=getDOBData.js.map